import React from 'react';
import ReactExport from 'react-data-export';
import '../../views/ServiceReport.css';
import '../forms/Button.css';
import { getLocalizedDateTime } from '../../localization/LocalizedString';
import addTimes from './TimeAddition';

const { ExcelFile } = ReactExport;
const { ExcelSheet, ExcelColumn } = ExcelFile;

const addOverallValues = (installationDocumentTasks) => {
  // copy
  const tasksWithOverallValues = installationDocumentTasks.slice(0);

  // calculate overall values
  let overallSeconds = 0;
  for (let i = 0; i < installationDocumentTasks.length; i += 1) {
    const installationDocumentTask = installationDocumentTasks[i];
    overallSeconds = addTimes(overallSeconds, installationDocumentTask.task.duration);
  }

  // create overall values
  tasksWithOverallValues.push({
    endCustomer: {},
    device: {},
    updatedAt: null,
    task: {
      time: null,
      duration: overallSeconds,
    },
  });

  return tasksWithOverallValues;
};

const ExportInstallationDocumentExcelButton = ({ currentLanguage, translate, data }) => {
  const tasksWithOverallValues = addOverallValues(data);

  return (
    <ExcelFile hideElement filename={translate('service_report.search.type_installationDocument')}>
      <ExcelSheet data={tasksWithOverallValues} name="Sheet1">
        <ExcelColumn label={translate('service_report.column_task.user')} value={(col) => col.user} />
        <ExcelColumn label={translate('service_report.column_task.employeeId')} value={(col) => col.employeeId} />
        <ExcelColumn label={translate('service_report.column_task.date')} value={(col) => col.updatedAt === null ? '' : getLocalizedDateTime(new Date(col.updatedAt), currentLanguage)} />
        <ExcelColumn label={translate('service_report.column_task.customer')} value={(col) => col.businessCustomer} />
        <ExcelColumn label={translate('service_report.column_task.consignorName')} value={(col) => col.orderData !== undefined ? col.orderData.consignorName : ''} />
        <ExcelColumn label={translate('service_report.column_task.terminal')} value={(col) => col.companyName} />
        <ExcelColumn label={translate('service_report.column_task.end_customer')} value={(col) => col.endCustomer.name} />
        <ExcelColumn label={translate('service_report.column_task.address')} value={(col) => col.endCustomer.place} />
        <ExcelColumn label={translate('service_report.column_task.deviceName')} value={(col) => currentLanguage === 'fi' ? col.device['deviceNamesFi'] : col.device['deviceNamesEn']} />
        <ExcelColumn label={translate('service_report.column_task.shipmentId')} value={(col) => col.device.shipmentIds} />
        <ExcelColumn label={translate('service_report.column_task.duration')} value={(col) => col.task.duration} />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default ExportInstallationDocumentExcelButton;



// WEBPACK FOOTER //
// ./src/components/servicereport/ExportInstallationDocumentExcelButton.js